import AScrollView from './ScrollView.vue';
export default AScrollView;


// WEBPACK FOOTER //
// ./src/packages/ScrollView/index.js